// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"23277707680ae02eaa77","453":"94fc4bb7b8ce1ea50ecf"}[chunkId] + ".js";
};